import React, { useEffect, useMemo } from 'react';

import { useGetEnrollments } from '../hooks/useGetEnrollment';
import { PersonalInformationPayload } from '../PersonalInformation/stores/usePersonalInformation.store';

import CheckingWrapper from './CheckingWrapper';
import useGetExistingAccountsQuery from './useGetExistingAccounts.query';

interface Props {
  employee: Partial<PersonalInformationPayload> | null;
  onSuccess: () => void;
}

const AccountsChecking: React.FC<Props> = ({ employee, onSuccess }) => {
  const { data, isLoading: areAccountsIdsLoading } = useGetEnrollments({ employeeId: employee?.employeeId });
  const accountsIds = useMemo(() => data?.map((account) => account?.id), [data]);
  const { isLoading, isSuccess, hasBalance } = useGetExistingAccountsQuery(accountsIds);
  const areAllAccountsBalancesAreZero = useMemo(() => accountsIds?.length ? isSuccess
    && !isLoading && !areAccountsIdsLoading && !hasBalance : true,
    [hasBalance, isSuccess, isLoading, areAccountsIdsLoading, accountsIds]);

  useEffect(() => {
    if (areAllAccountsBalancesAreZero) {
      onSuccess();
    }
  }, [areAllAccountsBalancesAreZero, onSuccess]);

  return (
    <CheckingWrapper
      testId="AccountsChecking"
      isSuccess={areAllAccountsBalancesAreZero}
      title="All account balances are zero"
      isLoading={isLoading || areAccountsIdsLoading}
    />
  );
};

export default AccountsChecking;
